import React from 'react';
import './SimpleLoadingScreen.css';
import { MDBSpinner } from 'mdb-react-ui-kit';

const SimpleLoadingScreen: React.FC = () => {
  return (
    <div className={'SimpleLoadingScreen show-creation-loading'}>
      <MDBSpinner role='status'>
        <span className='visually-hidden'>Loading...</span>
      </MDBSpinner>
    </div>
  );
};

export default SimpleLoadingScreen;
